import { IconInfoRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';

interface FirstOrderEnableTextProps {
  price: number;
}

export function FirstOrderText({ price }: FirstOrderEnableTextProps) {
  return (
    <Wrapper>
      <IconInfoRegular width={18} v3Color='gray500' style={{ minWidth: 18, height: 18 }} />
      <Text>
        첫구매가는 ID당 최초 1개 상품에만 적용되며 해당 상품 포함 {numberWithCommas(price)}원 이상 주문 시 구매 가능
        (배송비 제외)
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 14px 0 0 0;
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: ${vars.v3Color.gray500};
  word-break: keep-all;
`;

const Text = styled.p`
  margin-left: 3px;
`;
